import { http } from "Utils/http";
import { STATUSES } from "Utils/constants";
import { httpDownload } from "Utils/httpDownload";

export const DSS_INIT_URL = "/api/report/cf/initLoad";
export const DSS_VALIDATE_URL = "/api/report/cf/validate";
export const DSS_GENERATE_URL = "/api/report/cf/generate";

const loadDSSFormInfo = async (
  ACTIONS,
  formInfoDispatch,
  handleRadioChange,
  handleDateChange,
  handleTextChange,
  token
) => {
  formInfoDispatch({
    type: ACTIONS.SET_INITIAL_DATA,
    data: "",
    loading: true
  });

  let status = STATUSES.SUCCESS;

  await http
    .post(
      DSS_INIT_URL,
      {},
      { headers: { Authorization: token } }
    )
    .then((res) => {
      const payload = res?.data ?? res;
      if (res?.status !== 1 || (res?.globalErrorMessageList?.length > 0)) {
        status = STATUSES.ERROR;
        return Promise.reject({ status, data: res });
      }

      const data = {
        reportType: {
          radioButtons: [
            {
              id: "ds-summary-reportType_0",
              label: "Summary by Year and Month",
              name: "reportType",
              value: "Time",
              title: "Summary by Year and Month",
              isChecked: true,
              onChange: handleRadioChange,
              disabled: false
            },
            {
              id: "ds-summary-reportType_1",
              label: "Summary by Common Formats version and Event Types",
              name: "reportType",
              value: "Event",
              title: "Summary by Common Formats version and Event Types",
              isChecked: false,
              onChange: handleRadioChange,
              disabled: false
            }
          ],
          validation: { required: true, isInvalid: false, errors: [] },
          disabled: false
        },
        startDate: {
          value: "",
          validation: { required: false, isInvalid: false, errors: [] },
          onChange: handleDateChange,
          disabled: false
        },
        endDate: {
          value: "",
          validation: { required: false, isInvalid: false, errors: [] },
          onChange: handleDateChange,
          disabled: false
        },
        fileName: {
          value: "Data Submission Summary Report by Year and Month",
          validation: { required: true, isInvalid: false, errors: [] },
          onChange: handleTextChange,
          disabled: false
        }
      };

      formInfoDispatch({
        type: ACTIONS.SET_INITIAL_DATA,
        data,
        loading: false
      });
    })
    .catch(function (error) {
      status = STATUSES.ERROR;
      return Promise.reject({ status, data: error });
    });
};

const validateDSSRpt = async (
  token,
  formInfo,
  nameConverter,
  addErrorMessages,
  clearErrorMessages,
  getFieldValue
) => {
  clearErrorMessages(formInfo.data);

  const body = {
    reportType: getFieldValue("reportType", formInfo.data),
    startDate: getFieldValue("startDate", formInfo.data),
    endDate: getFieldValue("endDate", formInfo.data),
    reportFileName: getFieldValue("fileName", formInfo.data)
  };

  let status = STATUSES.SUCCESS;

  const res = await http
    .post(DSS_VALIDATE_URL, body, {
      headers: {
        Authorization: token
      }
    })
    .then((res) => {
      let x = 0;
      for (const [serverKey, uiKey] of Object.entries(nameConverter)) {
        const fieldErrObj = res.fieldErrors?.[serverKey];
        if (fieldErrObj) {
          const isFirst = x === 0;
          addErrorMessages(uiKey, serverKey, res, isFirst);
          status = STATUSES.ERROR;
          x = x + 1;
        }
      }
      return Promise.resolve({ status: status, data: res });
    })
    .catch(function (error) {
      status = STATUSES.ERROR;
      return Promise.reject({ status: status, data: error });
    });

  return res;
};

const generateDSSRpt = async (formInfo, token, getFieldValue) => {
  let status = STATUSES.SUCCESS;

  const body = {
    reportType: getFieldValue("reportType", formInfo.data),
    startDate: getFieldValue("startDate", formInfo.data),
    endDate: getFieldValue("endDate", formInfo.data),
    reportFileName: getFieldValue("fileName", formInfo.data)
  };

  const res = await httpDownload
    .post(DSS_GENERATE_URL, body, {
      responseType: "blob",
      headers: {
        Authorization: token
      }
    })
    .then((res) => {
      return Promise.resolve({ status: status, data: res });
    })
    .catch(function (error) {
      status = STATUSES.ERROR;
      return Promise.reject({ status: status, data: error });
    });

  return res;
};

export { loadDSSFormInfo, validateDSSRpt, generateDSSRpt };
